import axios from 'axios';
import { setInterceptors } from '@/api/common/interceptors';

function createInstance(url) {
    return axios.create({
        baseURL: url,
    });
}

function createInstanceWithAuth(url) {
    const instance = axios.create({
        baseURL: url,
    });

    return setInterceptors(instance);
}

function createMultiPartInstanceWithAuth(url) {
    const instance = axios.create({
        baseURL: url,
        headers: { "Content-Type": "multipart/form-data" },
    });

    return setInterceptors(instance);
}

function createBlobResponseInstanceWithAuth(url) {
    const instance = axios.create({
        baseURL: url,
        responseType: "blob",
    });

    return setInterceptors(instance);
}

export const instance = createInstance(process.env.VUE_APP_API_URL);
export const instanceWithAuth = createInstanceWithAuth(process.env.VUE_APP_API_URL);
export const multipartInstanceWithAuth = createMultiPartInstanceWithAuth(process.env.VUE_APP_API_URL);
export const blobResponseInstanceWithAuth = createBlobResponseInstanceWithAuth(process.env.VUE_APP_API_URL);
export const infotechInstance = createInstance(process.env.VUE_APP_INFOTECH_API_URL);
export const infotechInstanceWithAuth = createInstanceWithAuth(process.env.VUE_APP_INFOTECH_API_URL);
export const infotechMultipartInstanceWithAuth = createMultiPartInstanceWithAuth(process.env.VUE_APP_INFOTECH_API_URL);
export const infotechBlobResponseInstanceWithAuth = createBlobResponseInstanceWithAuth(process.env.VUE_APP_INFOTECH_API_URL);